let guestIdPromise = null;

const formatGuestId = (guestId = "") => ({
    raw: guestId,
    full: guestId,
    int: String(guestId)
        .split(".")
        .map((part) => part.padStart(3, "0"))
        .join(""),
});

export const getGuestId = async () => {
    const savedGuestId = localStorage.getItem("guest_id");

    if (savedGuestId) {
        return formatGuestId(savedGuestId);
    }

    if (!guestIdPromise) {
        guestIdPromise = (async () => {
            try {
                const res = await fetch("https://api.ipify.org?format=json");
                const data = await res.json();
                const ip = data?.ip || "unknown";

                localStorage.setItem("guest_id", ip);
                return ip;
            } catch (err) {
                const randomId = Math.floor(10000 + Math.random() * 90000);
                const fallbackGuestId = `${randomId}`;

                localStorage.setItem("guest_id", fallbackGuestId);
                return fallbackGuestId;
            }
        })();
    }

    const guestId = await guestIdPromise;
    return formatGuestId(guestId);
};

export const clearGuestId = () => {
    guestIdPromise = null;
    localStorage.removeItem("guest_id");
};
